import { SvgIcon, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import BusinessContactsFormModal from '../../../person/detailsPage/businessContacts/BusinessContactsFormModal';
import { Icons } from '../../icons/Icons';
import { useStyling } from '../../Theme';
import I18n from '../../i18n/I18n';

type BusinessContactsPreviewProps = {
    editEnabled: boolean;
    businessContacts: ContactInput[];
    onAddBusinessContact: () => void;
    /** When provided, replaces the local modal (e.g. the click bubbles to the row which opens the details screen). */
    onViewBusinessContacts?: () => void;
};

export default ({
    editEnabled,
    businessContacts,
    onAddBusinessContact,
    onViewBusinessContacts
}: BusinessContactsPreviewProps) => {
    const { theme } = useStyling();
    const [openBusinessContactView, setOpenBusinessContactView] = useState<boolean>(false);

    return (
        <>
            {editEnabled && !businessContacts?.length ? (
                <Tooltip title={<I18n token="add.business.contact" />}>
                    <SvgIcon
                        component={Icons.AddContact}
                        onClick={onAddBusinessContact}
                        sx={{ cursor: 'pointer', color: theme.palette.action.active }}
                    />
                </Tooltip>
            ) : businessContacts?.length ? (
                <SvgIcon
                    component={Icons.BusinessContact}
                    onClick={() =>
                        onViewBusinessContacts ? onViewBusinessContacts() : setOpenBusinessContactView(true)
                    }
                    sx={{ cursor: 'pointer', color: theme.palette.action.active }}
                />
            ) : (
                <></>
            )}
            {openBusinessContactView && (
                <BusinessContactsFormModal
                    isOpen
                    onClose={() => setOpenBusinessContactView(false)}
                    businessContacts={businessContacts}
                />
            )}
        </>
    );
};
